import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiInputAdornment: Components<Theme>['MuiInputAdornment'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      p: {
        fontSize: '0.875rem',
        lineHeight: 1.5,
        fontWeight: 500,
        color: theme.palette.text.primary,
        '.Mui-disabled &': {
          color: '#939DB8',
        },
        [`@media screen and (max-width: ${theme.breakpoints.values.sm}px)`]: {
          fontSize: '16px',
          lineHeight: 1.3,
        },
      },
    }),
    positionStart: {
      height: '100%',
      padding: '2px 2px 2px 4px',
      marginTop: '20px !important',
      backgroundColor: 'transparent',
      marginRight: '0',
    },
  },
};
